import axios from "axios";

export const getConfig = () =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/config")
      .then(resp => {
        resolve(resp.data);
      })
      .catch(err => {
        reject(err);
      });
  });
